import { TooltipItem } from 'chart.js';
import { format } from 'date-fns';
import { nb } from 'date-fns/locale';
import { months } from 'src/app/utils/date-utils';

declare let $: any; //Jquery deklarasjon

export const setTooltipTableValue = (
  tableName: string,
  unit: string,
  tooltipData: TooltipItem<'bar' | 'line'>[],
  customTitle?: string
) => {
  // Set title and clear data
  if (customTitle) {
    $(`#${tableName}_title`).html(customTitle);
  } else {
    $(`#${tableName}_title`).html(tooltipData[0].label);
  }
  $(`#${tableName}`).show();
  $(`#${tableName}_label`).html('');

  // Set label for each chart dataset
  tooltipData.map((tip) => {
    if (tip.formattedValue !== '0') {
      $(`#${tableName}_label`).append(
        tip.dataset.label + ': ' + tip.formattedValue + ` ${unit}<br />`
      );
    }
  });
};

export function addHours(date: Date, hours: number) {
  const result = new Date(date);
  result.setHours(result.getHours() + hours);
  return result;
}
export function addZeroBefore(n: number) {
  return (n < 10 ? '0' : '') + n;
}

export const titleTooltipCallback = (
  tooltipItems: TooltipItem<'bar' | 'line'>[],
  chart: 'day' | 'hour' | 'month' | 'year',
  unit: string,
  tableName?: string
) => {
  const value = tooltipItems.find((i) => i.raw !== 0.0);
  if (!value) {
    return undefined;
  }
  const setTable = (title: string) =>
    setTooltipTableValue(tableName, unit, tooltipItems, title);

  if (chart === 'day') {
    if (tableName) setTable(tooltipItems[0].label);
    return tooltipItems[0].label;
  }
  if (chart === 'hour') {
    const date = new Date(tooltipItems[0].label);
    const dateText = format(date, `d. MMMM 'kl' HH:mm`, { locale: nb });
    const hoursTo = addZeroBefore(addHours(date, 1).getHours()) + ':00';
    const title = dateText + '–' + hoursTo;
    if (tableName) setTable(title);
    return title;
  }
  if (chart === 'month') {
    if (tableName) setTable(months[tooltipItems[0].dataIndex]);
    return months[tooltipItems[0].dataIndex];
  }
  if (chart === 'year') {
    if (tableName) setTable(tooltipItems[0].label);
    return tooltipItems[0].label;
  }
};

export const labelTooltipCallback = (
  tooltipItem: TooltipItem<'bar' | 'line'>,
  unit: string
) => {
  const value = Number(tooltipItem.raw);
  if (value === 0 || isNaN(value) || tooltipItem.dataset.label == 'hide') {
    return undefined;
  }

  return `${tooltipItem.dataset.label}: ${value
    .toFixed(2)
    .toString()
    .replace('.', ',')} ${unit}`;
};
